import cloneDeep from 'lodash-es/cloneDeep';

export const BaseMixin = {
  props: {
    box: {
      type: Object,
      require: true
    }
  },

  data() {
    return {
      step: 'init',
      current_value: {}
    };
  },

  watch: {
    box: {
      handler: function(box) {
        this.current_value = cloneDeep(box);
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    mixin_set_step: function({ step }) {
      this.step = step;
    }
  }
};
